import { ReactNode } from 'react';
import { cn } from '@/utils/styles';

type ContainerProps = {
  readonly children: ReactNode;
  readonly className?: string;
  readonly size?: 'sm' | 'md' | 'lg' | 'xl' | 'full';
  readonly overflow?: boolean;
};

const sizeClasses = {
  sm: 'max-w-3xl', // ~768px
  md: 'max-w-5xl', // ~1024px
  lg: 'max-w-7xl', // ~1280px
  xl: 'max-w-[1440px]',
  full: 'max-w-full',
};

export function Container({ children, className, size = 'lg', overflow = false }: ContainerProps) {
  return (
    <div className={cn('mx-auto w-full px-4 sm:px-6 lg:px-8', !overflow ? sizeClasses[size] : undefined, className)}>
      {children}
    </div>
  );
}
